import { Link } from "react-router-dom";
import { FileText, RotateCcw, Mail } from "lucide-react";
import { RETURN_SHIPPING_COPY } from "@/lib/shipping";

// Every line here must be something the store can back: no price-comparison
// claims (prices are the supplier's), no phone line, no support team.
const reasons = [
  {
    icon: FileText,
    title: "Plain product facts",
    description: "We show what the supplier states and leave out what it gets wrong, rather than guess on your behalf. No invented \"was\" prices or reviews.",
    link: "How LoftLoom works",
    href: "/about",
  },
  {
    icon: RotateCcw,
    title: "30-Day Returns",
    description: `30 days from delivery. ${RETURN_SHIPPING_COPY}`,
    link: "Read the returns policy",
    href: "/returns",
  },
  {
    icon: Mail,
    title: "A person answers",
    description: "Questions about a piece, a measurement or an order: email hello@loftloom.com and we reply within 1 business day.",
    link: "Contact us",
    href: "/contact",
  },
];

export const WhyBuyFromUs = () => {
  return (
    <section className="border-t border-border bg-secondary/30">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <h2 className="font-sans text-[22px] md:text-[26px] font-semibold text-foreground mb-8 text-center">
          Why buy from LoftLoom?
        </h2>
        <div className="grid md:grid-cols-3 gap-8">
          {reasons.map((reason) => (
            <div key={reason.title} className="text-center">
              <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary/10 flex items-center justify-center">
                <reason.icon className="h-5 w-5 text-primary" />
              </div>
              <h3 className="text-[16px] font-bold text-foreground mb-2">{reason.title}</h3>
              <p className="text-[14px] text-muted-foreground leading-relaxed mb-2">
                {reason.description}
              </p>
              <Link to={reason.href} className="text-[14px] text-primary font-medium hover:underline">
                {reason.link}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
